import $ from 'jquery';
import 'what-input';
import Swiper from "swiper/dist/js/swiper.js";
import * as basicScroll from 'basicscroll';
import Headroom from "headroom.js";

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
// require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';


$(document).foundation();

$(document).ready(function() {

  // Fixed Header
  var scrollTop = 0;
  $(window).scroll(function(){
    scrollTop = $(window).scrollTop();

    if (scrollTop >= 2) {
      $('.header').addClass('background-header');
    } else if (scrollTop < 2) {
      $('.header').removeClass('background-header');
    }
  });

  // $(window).scroll(function(){
  //   scrollTop = $(window).scrollTop();

  //   if (scrollTop >= 60) {
  //     $('.top-banner-app').addClass('hide');
  //   } else if (scrollTop < 60) {
  //     $('.top-banner-app').removeClass('hide');
  //   }
  // });

  // Swiper
  var ourLocationSwiper = new Swiper('.swiper-container.swiper--location', {
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
  });
  // cardapioLojaSwiper
  var cardapioLojaSwiper = new Swiper('.cardapio-loja--categoria .swiper-container', {
    // spaceBetween: 6,
    slidesPerView: 3,
    centeredSlides: false,
    grabCursor: true,
    breakpoints: {
      640: {
        spaceBetween: 0,
        slidesPerView: 1,
        centeredSlides: true,
      },
    },
  });


  //Image Banner Parallax
  if ($('.section.image--banner').length > 0) {
    const imageBanners = []

    // Create an animation for each banner
    document.querySelectorAll('.section.image--banner').forEach((elem, i) => {

      // Crate an instance for the current element and store the instance in an array.
      // We start the animation later using the instances from the array.
      imageBanners.push(basicScroll.create({
        elem: elem,
        from: 'top-bottom',
        to: 'bottom-bottom',
        direct: true,
        props: {
          '--translateY': {
            from: '-20%',
            to: '0',
          }
        }
      }))
    })

    imageBanners.forEach((imageBanner) => imageBanner.start()

  )};

  // Section contact
  var $locationButton = $('.contact-location__buttons .button-switch');
  var $activeLocation = $('.section--contact .location');
  var $formPhone = $('.section--contact-form .section--contact-form__card');

  $locationButton.click(function(event) {
    event.preventDefault();

    var $clickedButton = $(this);
    var $locationIndex = $clickedButton.index();

    $locationButton.removeClass('is-active');
    $clickedButton.addClass('is-active');

    $activeLocation.addClass('location-inactive');
    $activeLocation.eq($locationIndex).removeClass('location-inactive');

    $formPhone.addClass('location-inactive');
    $formPhone.eq($locationIndex).removeClass('location-inactive');
  });

  //SmoothScroll Foundation
    //cardapio page
    $(".menu.category-navigation a").each(function(){
      let anchor = $(this).attr('href');

      $(this).on('click', function(e) {
        const scrollToAnchor = new Foundation.SmoothScroll.scrollToLoc($(anchor), {
          threshold: 50,
          offset: 200
        });
      });
    });

    //cardapio mobile page
    $(".cardapio-loja--nav .menu a, .cardapio-loja .off-canvas .menu.nav a").each(function(){
      let anchor = $(this).attr('href');

      $(this).on('click', function(e) {
        $('body').removeClass('is-off-canvas-open')
        $('.cardapio-loja .off-canvas').removeClass('is-open').addClass('is-closed');
        const scrollToAnchor = new Foundation.SmoothScroll.scrollToLoc($(anchor), {
          threshold: 100,
          offset: 0
        });
      });
    });

  // cardapio mobile page - visible content
  $(document).on("scroll", onScroll);

  // change active menu item on scroll
  function onScroll(event){
		var scrollPosition = $(document).scrollTop() + 50;
		$('.cardapio-loja--nav .menu a').each(function () {
			var currentLink = $(this);
			var refElement = $(currentLink.attr("href"));
			if (refElement.position().top <= scrollPosition && refElement.position().top + refElement.height() > scrollPosition) {
				$('.cardapio-loja--nav .menu a').removeClass("is-active");
        currentLink.addClass("is-active");
			}
			else {
				currentLink.removeClass("is-active");
			}
		});
  }

  // hide header and search on scroll down and show on scroll up
  var headerCombo = document.querySelector(".cardapio-loja--header");
  var headroom  = new Headroom(headerCombo);
  headroom.init();



   // Verifica se o botão com ID #cta-encomenda existe
    if ($('#cta-encomenda').length) {
        // Adiciona o evento de clique
        $('#cta-encomenda').on('click', function () {
            // Adiciona a classe ao elemento pai com a classe .cta-button-box
            $(this).closest('.cta-button-box').addClass('show-cta-button-encomenda');
        });
    }

});



$(function () {
    if ($('#cta-encomenda').length || $('#cta-cardapio').length) {
        // Adiciona ou remove a classe no clique do botão
        $('#cta-encomenda, #cta-cardapio').on('click', function (e) {
            e.stopPropagation(); // Evita que o clique no botão feche o box

            // Fecha todos os boxes abertos
            $('.cta-button-box').removeClass('show-cta-button-encomenda');

            // Abre o box associado ao botão clicado
            $(this).next('.cta-button-box').toggleClass('show-cta-button-encomenda');
        });

        // Fecha os boxes ao clicar fora deles
        $(document).on('click', function () {
            $('.cta-button-box').removeClass('show-cta-button-encomenda');
        });

        // Garante que o clique dentro do box não o feche
        $('.cta-button-box').on('click', function (e) {
            e.stopPropagation(); // Previne o fechamento
        });

        // Fecha os boxes ao pressionar a tecla Esc
        $(document).on('keydown', function (e) {
            if (e.key === 'Escape') {
                $('.cta-button-box').removeClass('show-cta-button-encomenda');
            }
        });
    }
});